import { ConversationChatMessageMini } from "./conversation.chat_message.mini";
import { TypingIndicator } from "./typing.indicator";
import { memo } from "react";

interface IProps {
  chatMessages?: any[];
  userIsTyping?: boolean;
}

export const ConversationMessageChatSessionMini = memo(
  ({ chatMessages = [], userIsTyping = false }: IProps) => {
    return (
      <div className="conversation-message conversation-message-chat-session-mini">
        <div className="conversation-message-content-mini">
          {chatMessages
            .map((message, i) => <ConversationChatMessageMini key={i} message={message} />)
            .reverse()}
          {userIsTyping && <TypingIndicator />}
        </div>
      </div>
    );
  }
);
